// Shim for react-native-background-timer on web platform
const BackgroundTimer = {
  start: (delay) => {
    console.warn('BackgroundTimer.start is not supported on web platform');
    return null;
  },
  stop: () => {
    console.warn('BackgroundTimer.stop is not supported on web platform');
  },
  runBackgroundTimer: (callback, delay) => {
    console.warn(
      'BackgroundTimer.runBackgroundTimer is not supported on web platform',
    );
    return setInterval(callback, delay);
  },
  stopBackgroundTimer: () => {
    console.warn(
      'BackgroundTimer.stopBackgroundTimer is not supported on web platform',
    );
  },
};

export default BackgroundTimer;
